import styled from "styled-components";
import { Container } from "./ui";
import Reveal from "./Reveal";
import config, { whatsappLink } from "../config";

export default function CTABanner({ accent, product }) {
  const msg = product
    ? `Përshëndetje! Dua të porosis Aroma Stick ${product}.`
    : undefined;

  return (
    <Wrap>
      <Container>
        <Reveal>
          <Panel style={accent ? { background: accent } : undefined}>
            <Blob aria-hidden="true" />
            <Content>
              <H2>
                Porositja bëhet
                <br />
                me një mesazh
              </H2>
              <P>
                Na shkruaj në WhatsApp, na thuaj cilin produkt do, dhe e marrim
                prej aty. Transporti është falas kudo në Kosovë.
              </P>
              <Row>
                <Cta
                  href={whatsappLink(msg)}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Porosit në WhatsApp
                </Cta>
                <Bundle>{config.bundle}</Bundle>
              </Row>
            </Content>
          </Panel>
        </Reveal>
      </Container>
    </Wrap>
  );
}

const Wrap = styled.section`
  padding: 0 0 88px;

  ${({ theme }) => theme.bp.md} {
    padding: 0 0 136px;
  }
`;

const Panel = styled.div`
  position: relative;
  overflow: hidden;
  border-radius: ${({ theme }) => theme.radius.lg};
  background: ${({ theme }) => theme.colors.brandDeep};
  color: #fff;
  padding: 52px 28px 56px;

  ${({ theme }) => theme.bp.md} {
    padding: 84px 72px 88px;
  }
`;

const Blob = styled.div`
  position: absolute;
  top: -40%;
  right: -12%;
  width: 60%;
  aspect-ratio: 1;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.09);
  pointer-events: none;
`;

const Content = styled.div`
  position: relative;
`;

const H2 = styled.h2`
  font-size: ${({ theme }) => theme.size.h2};
  margin-bottom: 18px;
`;

const P = styled.p`
  color: rgba(255, 255, 255, 0.82);
  max-width: 44ch;
  margin-bottom: 34px;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px 22px;
`;

const Cta = styled.a`
  display: inline-flex;
  align-items: center;
  padding: 16px 34px;
  border-radius: 999px;
  background: #fff;
  color: ${({ theme }) => theme.colors.ink};
  font-weight: 500;
  font-size: ${({ theme }) => theme.size.sm};
  transition: transform 0.35s ${({ theme }) => theme.ease};

  &:hover {
    transform: translateY(-2px);
  }
`;

const Bundle = styled.span`
  font-size: ${({ theme }) => theme.size.sm};
  color: rgba(255, 255, 255, 0.78);
  padding: 9px 18px;
  border: 1px dashed rgba(255, 255, 255, 0.4);
  border-radius: 999px;
`;
